import React, { useState } from 'react';
import {
  Typography,
  Box,
  LinearProgress,
  Button,
  // Alert,
  // Chip
} from '@mui/material';
// import { Warning as WarningIcon, Upgrade as UpgradeIcon } from '@mui/icons-material';
// import { SubscriptionDialog } from './SubscriptionDialog';

interface QuotaWarningProps {
  open: boolean; // can be ignored for inline display, but keep for compatibility
  onClose: () => void;
  onProceed?: () => void;
  quotaDetails: {
    current_usage?: number;
    limit?: number;
    plan?: string;
    requestedFormat?: string;
    allowedFormats?: string[];
  };
  actionType: string;
  canProceed: boolean;
}

export const QuotaWarning: React.FC<QuotaWarningProps> = ({
  onClose,
  onProceed,
  quotaDetails,
  actionType,
  canProceed
}) => {
  const [showSubscription, setShowSubscription] = useState(false);

  // const getWarningMessage = () => {
  //   if (actionType === 'tgs_generated') {
  //     return `You've reached your monthly TGS generation limit (${quotaDetails.limit}). Upgrade your plan to continue generating TGS plans.`;
  //   } else if (actionType.startsWith('export_')) {
  //     const format = quotaDetails.requestedFormat;
  //     return `${format} export is not available in your current plan. Upgrade to access all export formats.`;
  //   }
  //   return 'You have reached your usage limit for this feature.';
  // };

  const compliance =
    quotaDetails.current_usage && quotaDetails.limit
      ? Math.round((quotaDetails.current_usage / quotaDetails.limit) * 100)
      : 76; // fallback

  const handleGenerateTGS = () => {
    if (onProceed) {
      onProceed();
    } else {
      alert('TGS generated!');
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        maxWidth: 350,
        width: '100%',
        p: 2.5,
      }}
    >
      {/* Header */}
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          color: '#111827',
          mb: 1.5,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {/* Placeholder icon (replace with svg if needed) */}
        <span style={{ fontSize: '1.2rem' }}>⚙️</span>
        Compliance Tracker
      </Typography>

      {/* Progress bar */}
      <Box sx={{ width: '100%', mb: 2 }}>
        <LinearProgress
          variant="determinate"
          value={compliance}
          sx={{
            height: 8,
            borderRadius: 5,
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#bb1f22',
              borderRadius: 5,
            },
            backgroundColor: '#d1d5db',
          }}
        />
      </Box>

      {/* Subtext */}
      <Typography variant="body2" sx={{ mb: 2, color: '#111827' }}>
        Your traffic plan is currently {compliance}% compliant with official guidelines.
      </Typography>

      {/* Generate button */}
      {/* <Button
        variant="contained"
        sx={{
          backgroundColor: '#bb1f22',
          color: '#fff',
          borderRadius: 1,
          fontWeight: 600,
          width: 'fit-content',
          fontSize: '0.95rem',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: '#a01e1d',
          },
        }}
        onClick={handleGenerateTGS}
      >
        Generate TGS
      </Button> */}

      {/* --- Everything below is from old version but commented out --- */}

      {/* <Alert severity={canProceed ? "warning" : "error"} sx={{ mb: 2 }}>
        {getWarningMessage()}
      </Alert> */}

      {/* <Box mb={1} display="flex" alignItems="center" gap={1}>
        <Typography variant="subtitle2">Current Plan</Typography>
        <Chip 
          label={quotaDetails.plan || 'Free'} 
          color="primary" 
          variant="outlined" 
        />
      </Box> */}

      {/* Extra UI (usage bars, upgrade, subscription dialog, etc.) */}
      {/* <SubscriptionDialog 
        open={showSubscription}
        onClose={() => setShowSubscription(false)}
      /> */}
    </Box>
  );
};
